import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

// Fetch deleted users
export const fetchRecycleBin = createAsyncThunk('clients/fetchRecycleBin', async ({ page, account_type = '', type = 'deleted_users', searchTerm='' }) => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/users-list`, {
    params: {
      page,
      account_type,
      type,
      searchTerm
    },
  });
  return response.data;
});

// Restore a deleted user
export const restoreUser = createAsyncThunk('clients/restoreUser', async (userId, { dispatch }) => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/users-restore`, {
    id: userId, // Send userId as a POST parameter
  });

  if (response.data.success) {
    // Fetch the updated list of coaches after successful creation
    dispatch(fetchRecycleBin({ page: 1 })); // Pass the appropriate page number if needed
  }

  return response.data; // Assuming the API returns the restored user data
});


const recycleBinSlice = createSlice({
  name: 'admin_deleted_users',
  initialState: { users: [], currentPage: 1, totalPages: 1, loading: false, restoring: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetching deleted users
      .addCase(fetchRecycleBin.pending, (state) => { state.loading = true; })
      .addCase(fetchRecycleBin.fulfilled, (state, action) => {
        state.users = action.payload.data.data;
        state.currentPage = action.payload.data.current_page; // Default to 1 if current_page is undefined
        state.totalPages = action.payload.data.last_page; // Default to 0 if last_page is undefined
        state.loading = false;
      })
      .addCase(fetchRecycleBin.rejected, (state) => { state.loading = false; })
      
      // Restoring a deleted user
      .addCase(restoreUser.pending, (state) => { state.restoring = true; })
      .addCase(restoreUser.fulfilled, (state, action) => {
        // Optionally update the state to reflect the restored user
        const restoredUser = action.payload; // Assuming the restored user data is returned
        state.users = state.users.filter(user => user.id !== restoredUser.id); // Remove restored user from the recycle bin
        state.restoring = false;
      })
      .addCase(restoreUser.rejected, (state) => { state.restoring = false; });
  },
});

export default recycleBinSlice.reducer;